require("angular");/**
 * Webcam Directive
 *
 * (c) Jonas Hartmann http://jonashartmann.github.io/webcam-directive
 * License: MIT
 *
 * @version: 3.1.0
 */

//This library is no longer supported on github

'use strict';

(function() {
    // GetUserMedia is not yet supported by all browsers
    // Until then, we need to handle the vendor prefixes
    navigator.getMedia = ( navigator.getUserMedia ||
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia ||
        /*mozGetUserMedia is no longer working with new mozilla*/ (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) ||
        navigator.msGetUserMedia);

    // Checks if getUserMedia is available on the client browser
    window.hasUserMedia = function hasUserMedia() {
        return navigator.getMedia ? true : false;
    };
})();

angular.module('webcam', [])
    .directive('webcam', function () {
        return {
            template: '<div class="webcam" ng-transclude></div>',
            restrict: 'E',
            replace: true,
            transclude: true,
            scope:
                {
                    onError: '&',
                    onStream: '&',
                    onStreaming: '&',
                    placeholder: '=',
                    videoHeight: '=',
                    videoWidth: '='
                },
            link: function postLink($scope, element) {
                var videoElem = null,
                    videoStream = null,
                    placeholder = null;

                var _removeDOMElement = function _removeDOMElement(DOMel) {
                    if (DOMel) {
                        angular.element(DOMel).remove();
                    }
                };

                var onDestroy = function onDestroy() {
                    if (!!videoStream && typeof videoStream.stop === 'function') {
                        videoStream.stop();
                    }
                    if (!!videoElem) {
                        delete videoElem.src;
                    }
                };

                // called when camera stream is loaded
                var onSuccess = function onSuccess(stream) {
                    videoStream = stream;

                    try {
                        videoElem.srcObject = stream;
                    } catch (error) {
                        var vendorURL = window.URL || window.webkitURL;
                        videoElem.src = vendorURL.createObjectURL(stream);
                    }

                    /* Start playing the video to show the stream from the webcam */
                    videoElem.play();

                    /* Call custom callback */
                    if ($scope.onStream) {
                        $scope.onStream({stream: stream, video: videoElem});
                    }
                };

                // called when any error happens
                var onFailure = function onFailure(err) {
                    _removeDOMElement(placeholder);
                    if (console && console.log) {
                        console.log('The following error occured: ', err);
                    }

                    /* Call custom callback */
                    if ($scope.onError) {
                        $scope.onError({err:err});
                    }

                    return;
                };

                var startWebcam = function startWebcam() {
                    videoElem = document.createElement('video');
                    videoElem.setAttribute('class', 'webcam-live');
                    videoElem.setAttribute('autoplay', '');
                    element.append(videoElem);

                    if ($scope.placeholder) {
                        placeholder = document.createElement('img');
                        placeholder.setAttribute('class', 'webcam-loader');
                        placeholder.src = $scope.placeholder;
                        element.append(placeholder);
                    }

                    // Default variables
                    var isStreaming = false,
                        width = element.width = $scope.videoWidth || 320,
                        height = element.height = 0;

                    // Check the availability of getUserMedia across supported browsers
                    if (!window.hasUserMedia()) {
                        onFailure({code:-1, msg: 'Browser does not support getUserMedia.'});
                        return;
                    }

                    var mediaConstraint = { video: true, audio: false };
                    navigator.getMedia(mediaConstraint, onSuccess, onFailure);

                    /* Start streaming the webcam data when the video element can play
                     * It will do it only once
                     */
                    videoElem.addEventListener('canplay', function() {
                        if (!isStreaming) {
                            var scale = width / videoElem.videoWidth;
                            height = (videoElem.videoHeight * scale) || $scope.videoHeight;
                            videoElem.setAttribute('width', width);
                            videoElem.setAttribute('height', height);
                            isStreaming = true;
                            // console.log('Started streaming');

                            _removeDOMElement(placeholder);

                            /* Call custom callback */
                            if ($scope.onStreaming) {
                                $scope.onStreaming({video:videoElem});
                            }
                        }
                    }, false);
                };

                var stopWebcam = function stopWebcam() {
                    onDestroy();
                    videoElem.remove();
                };

                $scope.$on('$destroy', onDestroy);
                $scope.$on('START_WEBCAM', startWebcam);
                $scope.$on('STOP_WEBCAM', stopWebcam);

                startWebcam();

            }
        };
    });module.exports = "webcam";